import React from 'react';

const Card = ({ children, className, ...rest }) => (
  <div className={`rounded-lg shadow-lg bg-white ${className ?? ''}`}>{children}</div>
);

export default Card;
